import React from "react";
import Dropdown from "shared/Dropdown";
import { years, months, days } from "./dates";
import { Controller } from "react-hook-form";

const DateAndBirth = ({ isErrorExist, isServerErrorExist, control, setValue, birth = [] }) => {
  return (
    <>
      <Controller
        rules={{ required: true }}
        control={control}
        defaultValue={birth[1]}
        name="month"
        render={() => (
          <Dropdown
            name="month"
            placeholder="MM"
            items={months}
            setValues={setValue}
            defaultValue={birth[1]}
            error={isServerErrorExist("birthdate") || isErrorExist("month")}
          />
        )}
      />
      <Controller
        rules={{ required: true }}
        control={control}
        defaultValue={birth[2]}
        name="day"
        render={() => (
          <Dropdown
            name="day"
            placeholder="DD"
            items={days}
            defaultValue={birth[2]}
            setValues={setValue}
            error={isServerErrorExist("birthdate") || isErrorExist("day")}
          />
        )}
      />
      <Controller
        rules={{ required: true }}
        control={control}
        defaultValue={birth[0]}
        name="year"
        render={() => (
          <Dropdown
            name="year"
            placeholder="YY"
            items={years}
            defaultValue={birth[0]}
            setValues={setValue}
            error={isServerErrorExist("birthdate") || isErrorExist("year")}
          />
        )}
      />
    </>
  );
};

export default DateAndBirth;
